module.exports = __webpack_public_path__ + "static/img/face_error1.cd60a27c.jpg";